module.exports = "/fast-coin/img/coin/anim/in/coin_in_003.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_003.png
// module id = 2273
// module chunks = 5